import { render } from "./OpenQuestion.vue?vue&type=template&id=2f5c6407"
import script from "./OpenQuestion.vue?vue&type=script&lang=js"
export * from "./OpenQuestion.vue?vue&type=script&lang=js"

import "./OpenQuestion.vue?vue&type=style&index=0&id=2f5c6407&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__